import {mapState, mapMutations} from 'vuex'
export default {
  computed: {
    ...mapState('user', ['loginCount', 'USERINFO', 'PHONE_LOGIN_COUNT', 'PHONE_LOGIN_TYPE', 'USER_TOKEN']),
    ...mapState('device', ['safeNum', 'pageTitle', 'webWithoutNavigation']),
    ...mapState('scroll', ['SCROLL_TOP', 'SCROLL_TO_BOTTOM', 'SCROLL_ING'])
  },
  methods: {
    ...mapMutations('user', ['SET_USERINFO', 'SET_LOGIN_COUNT', 'SET_PHONE_LOGIN']),
    ...mapMutations('device', ['SET_SAFE_NUM', 'SET_PAGE_TITLE', 'SET_HAS_NAVIGATION']),
    ...mapMutations('scroll', ['SET_SCROLL_VAL', 'SET_SCROLL_ING'])
  }
}
